Jelly.URL.Is_Absolute = function(URL)
{
	// Check for protocol (http:, https:, ftp:, etc.)
	// Using regex to match URLs that start with a protocol
	return /^(?:[a-z]+:)?\/\//i.test(URL);
};